module.exports = __webpack_public_path__ + "media/images/carousel/banner_10-f8b1059f600528ec04762a6eb1d5890b.jpg";